import PropTypes from 'prop-types';
import { cloneElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from 'src/auth/hooks';
import { hasRole } from '@heyjob-dash/shared/utils/check-permission';
import { hasTimesheetClockings } from '@heyjob-dash/shared/data/timesheetTypes';

import { paths } from 'src/routes/paths';

export default function CompanyWorkspaceGuard({ children, feature, clockings = false }) {
  const { user } = useAuthContext();
  const companyId = user?.data?.current_company;
  const company = user?.data?.companies?.[companyId];
  if (!hasRole(user, ['Studio', 'Operatore']) || !companyId || !company
    || (feature && !company[feature])
    || (clockings && !company.timesheet_types?.some(hasTimesheetClockings))) {
    return <Navigate to={paths.dashboard.root} replace />;
  }
  return cloneElement(children, { key: companyId });
}

CompanyWorkspaceGuard.propTypes = {
  children: PropTypes.element.isRequired,
  feature: PropTypes.string,
  clockings: PropTypes.bool,
};
